/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserModelResult } from '../../models/user-model-result';

export interface ApiMenuGet$JsonOdataStreamingTrue$Params {
}

export function apiMenuGet$JsonOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiMenuGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiMenuGet$JsonOdataStreamingTrue.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserModelResult>;
    })
  );
}

apiMenuGet$JsonOdataStreamingTrue.PATH = '/api/menu';
